
const fetchArticles = () => {

    return axios.get('api/articles').then(response => {
        return response
    }).catch(error => {
        return Promise.reject(error)
    })

};

const fetchArticleData = (id) => {
    return axios.get('api/articles/' + id + '/edit').then(response => {
        return response
    }).catch(error => {
        return Promise.reject(error)
    })
}

const updateArticle = (data, image) => {

    let formData = new FormData();

    formData.append('_method', 'PATCH');
    formData.append('data', JSON.stringify(data))

    return axios.post('api/articles/' + data.id, formData).then((response) => {
        return response
    }).catch((error) => {
        return error.response
    });
}

const createArticle = (data) => {

    let formData = new FormData();

    formData.append('data', JSON.stringify(data))

    return axios.post('api/articles', formData).then((response) => {
        return response
    }).catch((error) => {
        return error.response
    });
}

const uploadTitleImage = (folder, image) => {

    let formData = new FormData();

    formData.append('file', image);

    return axios.post('api/titleimage/article/' + folder, formData, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        return error.response
    });

}

const loadCarouselItems = () => {
    return axios.get('api/magazine/promotions').then(response => {
        return response
    })
}

const emptyCarouselSlot = (article) => {

    let formData = new FormData();

    formData.append('_method', 'PATCH')
    formData.append('article', article)

    return axios.post('api/magazine/promotions/'+article, formData).then(response => {
        return response;
    })
}

const useCarouselSlot = (article, slot) => {

    let formData = new FormData();

    formData.append('_method', 'PATCH')
    formData.append('article', article)
    formData.append('slot', slot)

    return axios.post('api/magazine/promotions/use/'+article, formData).then(response => {
        return response;
    })
}

const loadPersonalities = (options) => {
    return axios.get('api/magazine/clients/list', { params: options }).then(response => {
        return response
    })
}

export default {
    fetchArticles,
    fetchArticleData,
    updateArticle,
    createArticle,
    uploadTitleImage,
    loadCarouselItems,
    emptyCarouselSlot,
    useCarouselSlot,
    loadPersonalities
};
